import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'

const FooterBox = styled.footer`
  background-color: #000;
  color: #fff;
  padding: 0 15px;
`
const FooterLogo = styled.div`
  max-width: 1180px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto 24px;
  padding: 24px 1.0875rem 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 1.0875rem;
    right: 1.0875rem;
    height: 1px;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.3);
  }
  
  img {
    max-width: 100%;
    max-height: 100px;
    margin-bottom: 24px;
    @media (min-width: 375px) {
      max-width: 320px;
    }
  }
`

const FooterLogoLinks = styled.div`
  display: flex;
  align-items: center;

  a {
    font-weight: 700;
    font-size: 18px;
    line-height: 1;
    color: #fff;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    text-decoration: none;
    margin-bottom: 24px;
  }

  svg {
    fill: #fff;
    margin-right: 10px;
  }
`

const FooterRow = styled.div`
  font-size: 14px;
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
  margin: 0 -15px 0;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  h3 {
    text-transform: uppercase;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: -1px;
    margin: 0 0 15px;
    padding: 0;
  }

  a {
    color: #fff;
    text-decoration: none;
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 0 0 5px;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 0 0 10px;
    }

    a {
      font-size: 18px;
      line-height: 1.2;
      letter-spacing: -1px;
      text-transform: uppercase;
      font-weight: 700;
    }
  }
`
const FooterCol = styled.div`
  flex: 1;
  margin-bottom: 30px;
  margin: 0 15px 30px;
  padding: 0 0 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);

  @media (min-width: 768px) {
    padding: 0 15px 30px;
    margin: 0;
    border: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.3);

    &:first-of-type {
      border: 0;
    }
  }
`
const FooterColSm = styled.div`
  flex: 1;
  padding: 0 15px;
`

const FooterWrap = styled.div`
  max-width: 1180px;
  padding: 0 1.0875rem;
  margin: 0 auto;
`

const FooterCopy = styled.div`
  text-align: center;
  font-size: 14px;
  padding: 24px 0;
  a {
    color: #fff;
    text-decoration: none;
  }
`

const Socials = styled.div`
  display: flex;
  align-items: center;

  a,
  span {
    margin-right: 20px;

    &:last-of-type {
      margin: 0;
    }
  }
`

const logo = `https://${process.env.GATSBY_DATA_PROVIDER_HOST}/logo.png`

const Footer = () => {
  return (
    <FooterBox className="footer">
      <FooterLogo>
        <Link to="/">
          <img src={logo} alt="Site Logo" />
        </Link>
        <FooterLogoLinks>
          <a href={'/'} data-salon-phone="" aria-label={'Phone'}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>
            </svg>
            <span></span>
          </a>
        </FooterLogoLinks>
      </FooterLogo>
      <FooterWrap>
        <FooterRow>
          <FooterCol>
            <h3 data-salon-name="">The Salon Shop</h3>
            <article>
              <p data-salon-address=""></p>
            </article>
          </FooterCol>
          <FooterCol>
            <h3>Opening hours</h3>
            <article data-salon-working-hours=""></article>
            {/* <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/">Our Story</a>
              </li>
              <li>
                <a href="/">How to</a>
              </li>
              <li>
                <a href="/">Education</a>
              </li>
              <li>
                <a href="/">Contact Us</a>
              </li>
            </ul> */}
          </FooterCol>
          <FooterCol>
            <h3>OUR BRANDS</h3>
            <FooterRow>
              <FooterColSm>
                <ol>
                  <li>
                    <Link to="/collections/paul-mitchell">Paul Mitchell</Link>
                  </li>
                  <li>
                    <Link to="/collections/tea-tree">Tea Tree</Link>
                  </li>
                  <li>
                    <Link to="/collections/marula-hair">Marula Oil</Link>
                  </li>
                  <li>
                    <Link to="/collections/mitch">Mitch</Link>
                  </li>
                  <li>
                    <Link to="/collections/john-paul-pet-1">John Paul Pet</Link>
                  </li>
                </ol>
              </FooterColSm>
              <FooterColSm>
                <ol>
                  <li>
                    <Link to="/collections/clean-beauty">Clean Beauty</Link>
                  </li>
                  <li>
                    <Link to="/collections/awapuhi-wild-ginger">Awapuhi</Link>
                  </li>
                  <li>
                    <Link to="/collections/neuro">Neuro</Link>
                  </li>
                  <li>
                    <Link to="/collections/trico-lab">trico.lab</Link>
                  </li>
                </ol>
              </FooterColSm>
            </FooterRow>
          </FooterCol>
          <FooterCol>
            <h3>SOCIAL NETWORKS</h3>
            <Socials>
              <a
                href={"/"}
                style={{
                  display: "none"
                }}
                target="_blank"
                rel="noopener noreferrer"
                data-facebook-link=""
                aria-label={'Facebook'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="28"
                  viewBox="0 0 320 512"
                >
                  <path
                    fill="currentColor"
                    d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                  />
                </svg>
              </a>
              <a
                href={"/"}
                style={{
                  display: "none"
                }}
                target="_blank"
                rel="noopener noreferrer"
                data-instagram-link=""
                aria-label={'Instagram'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                  />
                </svg>
              </a>
              <a href={"/"}
                 style={{
                   display: "none"
                 }}
                 target="_blank"
                 rel="noopener noreferrer"
                 data-tiktok-link=""
                 aria-label={'TikTok'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                     className="bi bi-tiktok" viewBox="0 0 24 24">
                  <path
                      d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/>
                </svg>
              </a>
              {/* <a href="https://youtube.com">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="16"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                  ></path>
                </svg>
              </a> */}
            </Socials>
          </FooterCol>
          <FooterCol>
            <h3>WE ACCEPT</h3>
            <Socials>
              <span>
                <svg
                  width="32"
                  height="32"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                  ></path>
                </svg>
              </span>
              <span>
                <svg
                  width="32"
                  height="32"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                  ></path>
                </svg>
              </span>
            </Socials>
          </FooterCol>
        </FooterRow>
      </FooterWrap>
      <FooterCopy>
        © 2021 <span data-salon-name=""></span> &nbsp;
        <a href="https://cyberworkshop.com.au" title="Site by CyberWorkshop" target={"_blank"} rel={"noreferrer"}>Site by CyberWorkshop</a>
      </FooterCopy>
    </FooterBox>
  )
}

export default Footer
